import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-platform-loader',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-zinc-900 via-zinc-800 to-zinc-900">
      <div class="flex flex-col items-center gap-8">
        <!-- Animated document scanner icon -->
        <div class="relative w-24 h-28">
          <!-- Document shape -->
          <div class="absolute inset-0 rounded-lg border-2 border-indigo-400/60 bg-zinc-800/80 shadow-lg shadow-indigo-500/10">
            <!-- Document lines -->
            <div class="mt-5 mx-3 space-y-2">
              <div class="h-1.5 rounded-full bg-indigo-400/20 w-3/4 animate-pulse"></div>
              <div class="h-1.5 rounded-full bg-indigo-400/20 w-full animate-pulse [animation-delay:150ms]"></div>
              <div class="h-1.5 rounded-full bg-indigo-400/20 w-5/6 animate-pulse [animation-delay:300ms]"></div>
              <div class="h-1.5 rounded-full bg-indigo-400/20 w-2/3 animate-pulse [animation-delay:450ms]"></div>
              <div class="h-1.5 rounded-full bg-indigo-400/20 w-4/5 animate-pulse [animation-delay:600ms]"></div>
            </div>
          </div>
          <!-- Scanning beam -->
          <div class="absolute left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-indigo-400 to-transparent scanner-beam"></div>
          <!-- Corner fold -->
          <div class="absolute top-0 right-0 w-5 h-5">
            <div class="absolute top-0 right-0 w-0 h-0 border-l-[20px] border-l-transparent border-t-[20px] border-t-zinc-900"></div>
            <div class="absolute top-[2px] right-[2px] w-0 h-0 border-l-[16px] border-l-transparent border-t-[16px] border-t-indigo-400/30"></div>
          </div>
        </div>

        <!-- Text -->
        <div class="flex flex-col items-center gap-3">
          <h2 class="text-xl font-semibold text-white tracking-wide">
            OCR Prime
          </h2>
          <div class="flex items-center gap-2">
            <span class="text-sm text-zinc-400">Loading platform data</span>
            <span class="inline-flex gap-0.5">
              <span class="w-1 h-1 rounded-full bg-indigo-400 animate-bounce [animation-delay:0ms]"></span>
              <span class="w-1 h-1 rounded-full bg-indigo-400 animate-bounce [animation-delay:150ms]"></span>
              <span class="w-1 h-1 rounded-full bg-indigo-400 animate-bounce [animation-delay:300ms]"></span>
            </span>
          </div>
        </div>

        <!-- Progress items -->
        <div class="flex gap-6 text-xs text-zinc-500">
          <div class="flex items-center gap-1.5">
            <div class="w-1.5 h-1.5 rounded-full bg-indigo-400 animate-ping"></div>
            Templates
          </div>
          <div class="flex items-center gap-1.5">
            <div class="w-1.5 h-1.5 rounded-full bg-violet-400 animate-ping [animation-delay:200ms]"></div>
            Fields
          </div>
          <div class="flex items-center gap-1.5">
            <div class="w-1.5 h-1.5 rounded-full bg-fuchsia-400 animate-ping [animation-delay:400ms]"></div>
            Structures
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    @keyframes scan {
      0%, 100% { top: 8px; opacity: 0; }
      10% { opacity: 1; }
      90% { opacity: 1; }
      50% { top: calc(100% - 8px); }
    }

    .scanner-beam {
      animation: scan 2s ease-in-out infinite;
      box-shadow: 0 0 12px 2px rgba(129, 140, 248, 0.4);
    }
  `]
})
export class PlatformLoaderComponent {}
